module.exports = __webpack_public_path__ + "img/1f_r_twodays@2x.33df2831.jpg";